import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

import { distances } from '../../../styles/constants';
import Card from '../../../components/Card';
import { H3 } from '../../../components/Typography';
import { DraftOrder } from '../../../types/orders';
import ExternalIds from '../../common/ExternalIds';

export interface DraftOrderIdProps extends WithTranslation {
    draft: DraftOrder;
}
const DraftOrderId = (
    {
        t,
        draft,
    }: DraftOrderIdProps
) => {
    return (
        <Card marginBottom={distances.normal}>
            <H3>
                {t('orders.fields.draft_order_id')}: {draft.id}
            </H3>
            <ExternalIds draftOrOrder={draft} />
        </Card>
    );
};

export default withTranslation()(DraftOrderId);
